import { WavesLadder } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const WavesLadderIcon = createLucideIcon(WavesLadder);
